function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M137.311 56.79H16.0597C7.19026 56.79 0.00012207 63.9801 0.00012207 72.8496V152.227C0.00012207 161.096 7.19026 168.286 16.0597 168.286H137.311C146.18 168.286 153.371 161.096 153.371 152.227V72.8496C153.371 63.9801 146.18 56.79 137.311 56.79Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M144.784 52.1286C136.072 41.5263 76.6853 0 76.6853 0C76.6853 0 17.2875 41.5263 8.58675 52.1286C-0.114016 62.7308 7.45081e-05 67.6395 7.45081e-05 73.344H153.371C153.371 67.6395 153.482 62.7308 144.784 52.1286Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M137.314 22.3237H16.0597V162.604H137.314V22.3237Z",
  fill: "#E6E6E6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M133.636 19.7187H19.735V159.999H133.636V19.7187Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5974e-05 76.6037V152.227C-0.00457191 155.628 1.07546 158.943 3.08324 161.688L58.3602 114.506L7.5974e-05 76.6037Z",
  fill: "url(#paint2_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M95.0132 114.506L150.287 161.688C152.295 158.943 153.375 155.628 153.371 152.227V76.6037L95.0132 114.506Z",
  fill: "url(#paint3_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0.0001223 152.227V152.001L56.7521 112.54L76.6962 98.6667L96.6376 112.54L153.371 152.001V152.227C153.371 154.336 152.956 156.424 152.149 158.373C151.342 160.322 150.159 162.092 148.668 163.583C147.176 165.075 145.406 166.258 143.457 167.065C141.508 167.872 139.42 168.287 137.311 168.286H16.0597C13.9507 168.287 11.8622 167.872 9.91357 167.065C7.96496 166.258 6.19442 165.075 4.70308 163.583C3.21173 162.092 2.02881 160.322 1.22186 158.373C0.414916 156.424 -0.000234536 154.336 0.0001223 152.227V152.227Z",
  fill: "url(#paint4_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M56.0594 113.009L0.00012207 152.001V149.089L56.0594 113.009Z",
  fill: "#F5CAAC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M97.3086 113.009L153.368 152.001V149.089L97.3086 113.009Z",
  fill: "#F5CAAC"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.7,
  x: 19.8083,
  y: 19.83,
  width: 113.819,
  height: 7.87769,
  fill: "#7554B8"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 33.7607,
  y: 53.4816,
  width: 85.9143,
  height: 18.2748,
  rx: 9.13742,
  stroke: "#9E87CD",
  strokeOpacity: 0.33,
  strokeWidth: 4
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M46.6778 63.1369L43.4414 62.2031L44.025 60.4098L47.2296 61.6513L47.0704 58.0011H48.9698L48.8106 61.715L51.9621 60.4947L52.5351 62.3198L49.2457 63.2536L51.3679 66.0762L49.8293 67.2009L47.9193 64.1449L46.0305 67.1054L44.4813 66.0231L46.6778 63.1369Z",
  fill: "#4F387D"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M58.4879 63.1369L55.2515 62.2031L55.8351 60.4098L59.0397 61.6513L58.8805 58.0011H60.7799L60.6207 61.715L63.7722 60.4947L64.3452 62.3198L61.0558 63.2536L63.178 66.0762L61.6394 67.2009L59.7294 64.1449L57.8406 67.1054L56.2914 66.0231L58.4879 63.1369Z",
  fill: "#4F387D"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M70.298 63.1369L67.0616 62.2031L67.6453 60.4098L70.8498 61.6513L70.6906 58.0011H72.59L72.4309 61.715L75.5824 60.4947L76.1554 62.3198L72.8659 63.2536L74.9881 66.0762L73.4495 67.2009L71.5395 64.1449L69.6508 67.1054L68.1015 66.0231L70.298 63.1369Z",
  fill: "#4F387D"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M82.1082 63.1369L78.8718 62.2031L79.4554 60.4098L82.66 61.6513L82.5008 58.0011H84.4002L84.241 61.715L87.3925 60.4947L87.9655 62.3198L84.6761 63.2536L86.7983 66.0762L85.2597 67.2009L83.3497 64.1449L81.4609 67.1054L79.9117 66.0231L82.1082 63.1369Z",
  fill: "#4F387D"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M93.9184 63.1369L90.682 62.2031L91.2656 60.4098L94.4702 61.6513L94.311 58.0011H96.2104L96.0512 61.715L99.2027 60.4947L99.7757 62.3198L96.4863 63.2536L98.6085 66.0762L97.0699 67.2009L95.1599 64.1449L93.2711 67.1054L91.7219 66.0231L93.9184 63.1369Z",
  fill: "#4F387D"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M105.729 63.1369L102.492 62.2031L103.076 60.4098L106.28 61.6513L106.121 58.0011H108.021L107.861 61.715L111.013 60.4947L111.586 62.3198L108.296 63.2536L110.419 66.0762L108.88 67.2009L106.97 64.1449L105.081 67.1054L103.532 66.0231L105.729 63.1369Z",
  fill: "#4F387D"
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 76.6853,
  y1: 56.79,
  x2: 76.6853,
  y2: 168.286,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB580"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#FF6B00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF6B00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 76.6853,
  y1: 0,
  x2: 76.6853,
  y2: 73.3358,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB580"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF6B00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 29312.5,
  y1: 24068.7,
  x2: 29312.5,
  y2: 50720.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB580"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E05F02"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 29406.2,
  y1: 24068.7,
  x2: 29406.2,
  y2: 50720.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB580"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E05F02"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 76.6853,
  y1: 98.6667,
  x2: 76.6853,
  y2: 168.286,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD9BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFB580"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.765625,
  stopColor: "#FF8F40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DF5E00"
})));

function SvgMailImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 169,
    viewBox: "0 0 154 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref4), _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref9), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref10), _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailImg);
export default __webpack_public_path__ + "static/media/mailImg.30c1b46e.svg";
export { ForwardRef as ReactComponent };